@use '@lib/assets/styles/main.scss' as *;

.icon {
  object-fit: cover;
  width: 48px;
  height: 48px;
  border-radius: 4px;
  border: 1px solid $gray200;
}

.offlineLabel {
  margin-top: 8px;
}
